import { c as _c } from "react/compiler-runtime";
import { env } from '@cc-shopping/platform-env';
import { BaseEmbed } from '@cc-shopping/ui/composites/BaseEmbed';
import type { StructuredContentDocumentWithRenderer } from '../../hydration/types';
export type ContainerProps = StructuredContentDocumentWithRenderer<{
  id: string;
}>;
export const Infogram = t0 => {
  const $ = _c(3);
  const {
    props: t1
  } = t0;
  const {
    id
  } = t1;
  const embedUrl = `https://e.infogr.am/${id}?src=embed#async_embed`;
  let t2;
  if ($[0] !== embedUrl || $[1] !== id) {
    t2 = <BaseEmbed src={embedUrl} id={id} title="Infogram" deployableEnv={env.NEXT_PUBLIC_NW_URL} />;
    $[0] = embedUrl;
    $[1] = id;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};